import { useLayoutEffect, useRef, useState } from "react";

// Returns a ref for the chart frame and the factor that fits the fixed-size canvas into the frame width.
export function useMacChartScale(canvasWidth: number) {
    const frameRef = useRef<HTMLDivElement>(null);
    const [scale, setScale] = useState(1);

    useLayoutEffect(() => {
        const frame = frameRef.current;
        if (!frame) {
            return undefined;
        }

        const updateScale = () => {
            const width = frame.getBoundingClientRect().width;
            if (width > 0) {
                setScale(width / canvasWidth);
            }
        };

        const observer = new ResizeObserver(updateScale);
        observer.observe(frame);
        updateScale();

        return () => observer.disconnect();
    }, [canvasWidth]);

    return { frameRef, scale };
}
